import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseSingleSelectComponent } from '@zaoblako/web/shared/components/base-single-select/base-single-select.component';
import { AgentFindInterface } from '@zaoblako/shared/modules/ai/dtos/agent/agent-find.dto';
import { AiAgentService } from '@zaoblako/web/core/services/directory/ai-agent.service';
import { Observable } from 'rxjs';
import { DropdownBaseQueryInterface } from '@zaoblako/shared/common/dtos/dropdown-base-query.dto';
import { PaginationFindInterface } from '@zaoblako/shared/common/dtos/pagination-find.dto';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';

@Component({
  selector: 'crm-ai-agent-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, SpinnerComponent],
  templateUrl: './ai-agent-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiAgentSingleSelectComponent extends BaseSingleSelectComponent<AgentFindInterface> implements OnChanges {
  public availableModule = 'BASIS';

  @Input() public isAutoReply = false;
  @Input() public onlyActive = false;

  public constructor(private readonly aiAgentService: AiAgentService) {
    super();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.isAutoReply || changes.onlyActive) {
      this.firstLoad();
    } else {
      super.ngOnChanges(changes);
    }
  }

  public findById(id: number): Observable<AgentFindInterface> {
    return this.aiAgentService.findById(id);
  }

  public findWithPagination(
    queryParams: Partial<DropdownBaseQueryInterface>
  ): Observable<PaginationFindInterface<AgentFindInterface>> {
    return this.aiAgentService.findWithPagination({
      ...queryParams,
      isAutoReply: this.isAutoReply,
      onlyActive: this.onlyActive
    });
  }
}
